export default "__VITE_ASSET__BfGXleVY__"